import React from 'react';
import { css, cx } from '@emotion/css';
import { theme } from '../../theme';
const containerStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});
const baseStatusStyles = css({
    minWidth: '0px',
    backgroundColor: theme.colors.lightBlue,
    borderRadius: '50%',
    width: '12px',
    height: '12px',
});
const overriddenStatusStyles = css({
    backgroundColor: theme.colors.plum,
});
const pendingStatusStyles = css({
    backgroundColor: theme.colors.banana,
});
export const Status = ({ status, text }) => (React.createElement("div", { className: containerStyles },
    React.createElement("div", { className: cx({
            [baseStatusStyles]: true,
            [overriddenStatusStyles]: status === 'overridden',
            [pendingStatusStyles]: status === 'pending',
        }) }),
    text && React.createElement("div", null, text)));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhdHVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29tbW9uL1N0YXR1cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFhLE1BQU0sT0FBTyxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxHQUFHLEVBQUUsRUFBRSxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFFcEMsTUFBTSxlQUFlLEdBQUcsR0FBRyxDQUFDO0lBQzFCLE9BQU8sRUFBRSxNQUFNO0lBQ2YsVUFBVSxFQUFFLFFBQVE7SUFDcEIsR0FBRyxFQUFFLEtBQUs7Q0FDWCxDQUFDLENBQUM7QUFFSCxNQUFNLGdCQUFnQixHQUFHLEdBQUcsQ0FBQztJQUMzQixRQUFRLEVBQUUsS0FBSztJQUNmLGVBQWUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLFNBQVM7SUFDdkMsWUFBWSxFQUFFLEtBQUs7SUFDbkIsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsTUFBTTtDQUNmLENBQUMsQ0FBQztBQUVILE1BQU0sc0JBQXNCLEdBQUcsR0FBRyxDQUFDO0lBQ2pDLGVBQWUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLElBQUk7Q0FDbkMsQ0FBQyxDQUFDO0FBRUgsTUFBTSxtQkFBbUIsR0FBRyxHQUFHLENBQUM7SUFDOUIsZUFBZSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsTUFBTTtDQUNyQyxDQUFDLENBQUM7QUFPSCxNQUFNLENBQUMsTUFBTSxNQUFNLEdBQW9CLENBQUMsRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQzNELDZCQUFLLFNBQVMsRUFBRSxlQUFlO0lBQzdCLDZCQUNFLFNBQVMsRUFBRSxFQUFFLENBQUM7WUFDWixDQUFDLGdCQUFnQixDQUFDLEVBQUUsSUFBSTtZQUN4QixDQUFDLHNCQUFzQixDQUFDLEVBQUUsTUFBTSxLQUFLLFlBQVk7WUFDakQsQ0FBQyxtQkFBbUIsQ0FBQyxFQUFFLE1BQU0sS0FBSyxTQUFTO1NBQzVDLENBQUMsR0FDRjtJQUNELElBQUksSUFBSSxpQ0FBTSxJQUFJLENBQU8sQ0FDdEIsQ0FDUCxDQUFDIn0=